import { render, staticRenderFns } from "./SelfAssessmentAgilityTest.vue?vue&type=template&id=d8fae40a&scoped=true&"
import script from "./SelfAssessmentAgilityTest.vue?vue&type=script&lang=ts&"
export * from "./SelfAssessmentAgilityTest.vue?vue&type=script&lang=ts&"
import style0 from "./SelfAssessmentAgilityTest.vue?vue&type=style&index=0&id=d8fae40a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8fae40a",
  null
  
)

export default component.exports